import React from 'react';
import {Container, Row, Col, Media} from 'reactstrap';
// import {Row} from 'react-bootstrap';
import profile from '../profile.json';

import uct from '../images/uct.png';
import Univtana from '../images/UnivTana.png';

let imagelogo ={
    uct, Univtana
};


class Education extends React.Component {
  render() {
    return <Container>
      <Row>
        <Col>
          {profile.studies.map(function (study, i) {
            return <Media key={i}>
              <Media left top href={study.url}>
                <Media object src={imagelogo[study.logo]} alt={study.institute}/>
              </Media>
              <Media body>
                <Media heading>
                  <a href={study.url}>{study.institute}</a>
                </Media>
                  <RenderStudy study={study} />
              </Media>
            </Media>
          })}
        </Col>
      </Row>
    </Container>
  }
}

const RenderStudy = (props) => {
  const study = props.study;
  const title_field = (study) =>{
    return (<Col><b>{study.title}</b> in {study.subject}, {study.graduationYear}</Col>);}

  return(
    <div>
      <div style={{margin: "5px 0px", padding: "0px"}}>
        <Row>
          <Col className="formLabel">Title:</Col>
        </Row>
        <Row>
          {title_field(study)}
        </Row>    
      </div>
      <div  style={{margin: "5px 0px", padding: "0px"}}>
        <Row>
          <Col className="formLabel">Thesis Title:</Col>
        </Row>
        <Row>
          <Col><i>"{study.thesis_title}"</i>  (<a href={study.thesis_link}>Link</a>) </Col>
        </Row>    
      </div>
      <div style={{margin: "5px 0px", padding: "0px"}}>
        <Row>
          <Col className="formLabel">Thesis Description:</Col>
        </Row>
        <Row>
          <Col> 
            <div dangerouslySetInnerHTML={{__html: study.thesis_description}}/>
          </Col>
        </Row>    
      </div>
    </div>
  );
}

export default Education;